// ===============================
// Driver Season Game
// ===============================

export const DRIVER_SEASON_START_COMPLETED =
  "overcut/driverSeason/START_COMPLETED";

export const DRIVER_SEASON_GET_COMPLETED =
  "overcut/driverSeason/GET_COMPLETED";

export const DRIVER_SEASON_VALIDATE_COMPLETED =
  "overcut/driverSeason/VALIDATE_COMPLETED";

export const DRIVER_SEASON_REVEAL_COMPLETED =
  "overcut/driverSeason/REVEAL_COMPLETED";

export const DRIVER_SEASON_CLEAR =
  "overcut/driverSeason/CLEAR";
